import React from "react";
import { Outlet } from "react-router-dom";

const Report: React.FC = () => {
  return <Outlet />;
};

export default Report;